var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentPerformance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 41,
    viewBox: "0 0 48 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5754 36.9045C39.5754 38.6251 38.1806 40.0199 36.46 40.0199H14.2777C13.5424 40.0199 12.9463 39.4238 12.9463 38.6884C12.9463 37.9531 13.5424 37.357 14.2777 37.357H36.9125V18.7166H30.4815C29.6212 18.7166 28.9238 18.0192 28.9238 17.1589V10.7279H15.6092V18.7166C15.6092 19.4519 15.0131 20.048 14.2777 20.048C13.5424 20.048 12.9463 19.4519 12.9463 18.7166V11.1803C12.9463 9.45975 14.3411 8.06494 16.0617 8.06494H32.1193L39.1192 15.0649C39.4113 15.357 39.5754 15.7532 39.5754 16.1663V36.9045ZM31.5867 16.0537H36.3799L31.5867 11.2604V16.0537Z",
    fill: "url(#paint0_linear_2592_10391)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9545 33.7638C10.6578 34.0606 10.1792 34.0688 9.87239 33.7825L9.0198 32.9867C8.69569 32.6842 8.6891 32.1726 9.0053 31.8618L15.5971 25.3837C15.902 25.0841 16.3914 25.0862 16.6937 25.3885L20.9228 29.6176C21.227 29.9218 21.7201 29.9218 22.0243 29.6176L27.1988 24.4431L29.0629 26.3072L22.0243 33.3457C21.7201 33.6499 21.227 33.6499 20.9228 33.3457L16.6985 29.1214C16.3943 28.8172 15.9012 28.8172 15.597 29.1214L10.9545 33.7638Z",
    fill: "url(#paint1_linear_2592_10391)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6349 22.4625C25.0101 22.5667 24.7643 23.3336 25.2123 23.7815L29.7292 28.2984C30.1771 28.7464 30.944 28.5006 31.0482 27.8758L31.9516 22.4554C32.0394 21.9283 31.5824 21.4713 31.0553 21.5591L25.6349 22.4625Z",
    fill: "url(#paint2_linear_2592_10391)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2592_10391",
    x1: -2.77865,
    y1: 11.0152,
    x2: 150.818,
    y2: 101.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#D82E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4246,
    stopColor: "#E35353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6462,
    stopColor: "#EB6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8429,
    stopColor: "#F07D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#F28322"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2592_10391",
    x1: -3.76154,
    y1: 25.3528,
    x2: 46.4104,
    y2: 99.7371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#D82E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4246,
    stopColor: "#E35353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6462,
    stopColor: "#EB6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8429,
    stopColor: "#F07D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#F28322"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2592_10391",
    x1: 19.4246,
    y1: 22.1175,
    x2: 60.8042,
    y2: 51.4066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#D82E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4246,
    stopColor: "#E35353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6462,
    stopColor: "#EB6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8429,
    stopColor: "#F07D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#F28322"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentPerformance);
export default __webpack_public_path__ + "static/media/document-performance.64221b2655972b370682e5da8e6b1752.svg";
export { ForwardRef as ReactComponent };